import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

function mkiv() {
  const [userCount, setUserCount] = useState(0);
  const [commentCount, setCommentCount] = useState(0);
  const [feedbackCount, setFeedbackCount] = useState(0);
  const [followedStocksCount, setFollowedStocksCount] = useState(0);
  const [postCount, setPostCount] = useState(0);
  const [upvoteCount, setUpvoteCount] = useState(0);
  const [details, setDetails] = useState(null);
  const [view, setView] = useState('overview');
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('Admin Dashboard');
  const [authenticated, setAuthenticated] = useState(false);
  const [code, setCode] = useState('');
  const db = getFirestore();

  useEffect(() => {
    const fetchCounts = async () => {
      const userSnapshot = await getDocs(collection(db, "users"));
      setUserCount(userSnapshot.size);

      const commentSnapshot = await getDocs(collection(db, "comments"));
      setCommentCount(commentSnapshot.size);

      const feedbackSnapshot = await getDocs(collection(db, "feedback"));
      setFeedbackCount(feedbackSnapshot.size);

      const followedStocksSnapshot = await getDocs(collection(db, "followedStocks"));
      setFollowedStocksCount(followedStocksSnapshot.size);

      const postSnapshot = await getDocs(collection(db, "posts"));
      setPostCount(postSnapshot.size);

      const upvoteSnapshot = await getDocs(collection(db, "upvotes"));
      setUpvoteCount(upvoteSnapshot.size);
    };
    fetchCounts();
  }, [db]);

  const fetchDetails = async (collectionName, newTitle) => {
    setLoading(true);
    const snapshot = await getDocs(collection(db, collectionName));
    const items = snapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
    setDetails({ collectionName, items });
    setView('details');
    setTitle(newTitle);
    setLoading(false);
  };

  const deleteItem = async (collectionName, id) => {
    await deleteDoc(doc(db, collectionName, id));
    setDetails(prev => ({
      ...prev,
      items: prev.items.filter(item => item.id !== id),
    }));
  };

  const renderDetails = () => {
    if (!details) return null;
    switch (details.collectionName) {
      case 'users':
        return details.items.map((item) => (
          <div key={item.id} className="border rounded p-4 shadow mb-4 relative bg-white">
            <p><strong>Fulde navn:</strong> {item.fullName}</p>
            <p><strong>Email:</strong> {item.email}</p>
            <p><strong>UID:</strong> {item.uid}</p>
            <button
              onClick={() => deleteItem('users', item.id)}
              className="absolute top-2 right-2 text-red-500 hover:text-red-700"
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
          </div>
        ));
      case 'comments':
        return details.items.map((item) => (
          <div key={item.id} className="border rounded p-4 shadow mb-4 relative bg-white">
            <p><strong>Forfatter ID:</strong> {item.authorId}</p>
            <p><strong>Beskrivelse:</strong> {item.content}</p>
            <p><strong>Upvotes:</strong> {item.upvotes}</p>
            <p><strong>Forfatter navn:</strong> {item.authorName}</p>
            <p><strong>Indlæg ID:</strong> {item.postId}</p>
            <button
              onClick={() => deleteItem('comments', item.id)}
              className="absolute top-2 right-2 text-red-500 hover:text-red-700"
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
          </div>
        ));
      case 'feedback':
        return details.items.map((item) => (
          <div key={item.id} className="border rounded p-4 shadow mb-4 relative bg-white">
            <p><strong>Rating:</strong> {item.rating}</p>
            <p><strong>Feedback:</strong> {item.feedback}</p>
            <button
              onClick={() => deleteItem('feedback', item.id)}
              className="absolute top-2 right-2 text-red-500 hover:text-red-700"
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
          </div>
        ));
      case 'followedStocks':
        const stockCounts = details.items.reduce((acc, item) => {
          acc[item.symbol] = (acc[item.symbol] || 0) + 1;
          return acc;
        }, {});
        return Object.entries(stockCounts).map(([symbol, count]) => (
          <div key={symbol} className="border rounded p-4 shadow mb-4 relative bg-white">
            <p><strong>Symbol:</strong> {symbol}</p>
            <p><strong>Antal:</strong> {count}</p>
            <button
              onClick={() => deleteItem('followedStocks', symbol)}
              className="absolute top-2 right-2 text-red-500 hover:text-red-700"
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
          </div>
        ));
      case 'posts':
        return details.items.map((item) => (
          <div key={item.id} className="border rounded p-4 shadow mb-4 relative bg-white">
            <p><strong>Upvotes:</strong> {item.upvotes}</p>
            <p><strong>Forfatter navn:</strong> {item.authorName}</p>
            <p><strong>Beskrivelse:</strong> {item.content}</p>
            <button
              onClick={() => deleteItem('posts', item.id)}
              className="absolute top-2 right-2 text-red-500 hover:text-red-700"
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
          </div>
        ));
      default:
        return null;
    }
  };

  const handleLogin = () => {
    if (code === 'Rcs64pgw') {
      setAuthenticated(true);
    } else {
      alert('Incorrect code');
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen p-8 text-gray-800">
      {!authenticated ? (
        <div className="max-w-sm mx-auto bg-white p-6 rounded shadow text-center">
          <h1 className="text-xl mb-4 font-bold">Admin Login</h1>
          <input
            type="password"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="border rounded w-full p-2 mb-4"
            placeholder="Adgangskode"
          />
          <button
            onClick={handleLogin}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Login
          </button>
        </div>
      ) : (
        <div className="max-w-6xl mx-auto">
          <div className="bg-white p-4 rounded shadow mb-4 flex items-center justify-between">
            <h1 className="text-2xl font-bold">{title}</h1>
            {view === 'details' && (
              <button
                onClick={() => { setView('overview'); setTitle('Admin Dashboard'); }}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Tilbage
              </button>
            )}
          </div>

          {view === 'overview' ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
              <div
                className="bg-white rounded shadow p-4 cursor-pointer text-center hover:bg-blue-50"
                onClick={() => fetchDetails('users', 'Brugere')}
              >
                <h2 className="text-lg font-semibold">Brugere</h2>
                <p className="text-xl">{userCount}</p>
              </div>
              <div
                className="bg-white rounded shadow p-4 cursor-pointer text-center hover:bg-blue-50"
                onClick={() => fetchDetails('comments', 'Kommentarer')}
              >
                <h2 className="text-lg font-semibold">Kommentarer</h2>
                <p className="text-xl">{commentCount}</p>
              </div>
              <div
                className="bg-white rounded shadow p-4 cursor-pointer text-center hover:bg-blue-50"
                onClick={() => fetchDetails('feedback', 'Feedback')}
              >
                <h2 className="text-lg font-semibold">Feedback</h2>
                <p className="text-xl">{feedbackCount}</p>
              </div>
              <div
                className="bg-white rounded shadow p-4 cursor-pointer text-center hover:bg-blue-50"
                onClick={() => fetchDetails('followedStocks', 'Fulgte aktier')}
              >
                <h2 className="text-lg font-semibold">Fulgte aktier</h2>
                <p className="text-xl">{followedStocksCount}</p>
              </div>
              <div
                className="bg-white rounded shadow p-4 cursor-pointer text-center hover:bg-blue-50"
                onClick={() => fetchDetails('posts', 'Indlæg')}
              >
                <h2 className="text-lg font-semibold">Indlæg</h2>
                <p className="text-xl">{postCount}</p>
              </div>
            </div>
          ) : (
            <div className="mt-8">
              {loading ? (
                <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin mx-auto" />
              ) : (
                renderDetails()
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default mkiv;